import { render, staticRenderFns } from "./staffEdit.vue?vue&type=template&id=3b12cde8&"
import script from "./staffEdit.vue?vue&type=script&lang=js&"
export * from "./staffEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports